import { createContext, useContext } from 'react'
import { useCheckins } from '../hooks/useCheckins'

const CheckinContext = createContext(null)

export function CheckinProvider({ children }) {
  const checkins = useCheckins()
  return <CheckinContext.Provider value={checkins}>{children}</CheckinContext.Provider>
}

export function useCheckinContext() {
  return useContext(CheckinContext)
}
